import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef, TemplateRef, AfterViewChecked } from '@angular/core';
import { NgForm, NgModel, Validators, FormArray, FormGroup, FormControl } from '@angular/forms';

import { environment } from 'environments/environment';

import { AngularFireDatabase } from '@angular/fire/database';

import { AccountService } from '@services/account.service';
import { DetailPageService } from '@services/support/detail-page.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '@services/support/modal.service';
import { LoaderService } from '@services/support/loader.service';
import { FlashMessagesService } from '@mobilestar/ngx-flash-messages';
import { UtilityService } from '@services/support/utility.service';
import { Account, AccountWorkflowReports, AccountWorkflowUsers, AccountWorkflows } from '@models/Account';

import { map, distinctUntilChanged, first } from 'rxjs/operators';
import { Subscription, Observable, interval } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

import infoImages from '@assets/info/infoImages.json';

declare var QRCode: any;

@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss']
})
export class AccountDetailsComponent implements OnInit, OnDestroy, AfterViewChecked {

  static ACTION_DETAILS: string = "details";
  static ACTION_EDIT: string = "edit";
  static ACTION_NEW: string = "new";
  /**** Access in template ****/
  get ACTION_DETAILS() { return AccountDetailsComponent.ACTION_DETAILS; }
  get ACTION_EDIT() { return AccountDetailsComponent.ACTION_EDIT; }
  get ACTION_NEW() { return AccountDetailsComponent.ACTION_NEW; }

  @ViewChild("featureAddOnInfoModal", { static: true }) private featureAddOnInfoModal: TemplateRef<any>;

  @ViewChild("sessionsTemplate", { static: true }) private sessionsTemplate: TemplateRef<any>;
  @ViewChild("loginAttemptsTemplate", { static: true }) private loginAttemptsTemplate: TemplateRef<any>;
  @ViewChild("resendExportTemplate", { static: true }) private resendExportTemplate: TemplateRef<any>;
  @ViewChild("kickReasonsTemplate", { static: true }) private kickReasonsTemplate: TemplateRef<any>;

  @ViewChild('accountForm', { static: true }) accountForm: NgForm;
  @ViewChild("deleteTemplate", { static: true }) private deleteTemplate: TemplateRef<any>;
  @ViewChild("wipeTemplate", { static: true }) private wipeTemplate: TemplateRef<any>;
  @ViewChild("updateWarningTemplate", { static: true }) private updateWarningTemplate: TemplateRef<any>;

  @ViewChild('passwordForm', { static: true }) passwordForm: NgForm;
  @ViewChild("changePassTemplate", { static: true }) private changePassTemplate: TemplateRef<any>;

  @ViewChild('archiveForm', { static: true }) archiveForm: NgForm;
  @ViewChild('smsForm', { static: true }) smsForm: NgForm;
  @ViewChild("deleteSmsLicenseTemplate", { static: true }) private deleteSmsLicenseTemplate: TemplateRef<any>;

  @ViewChild("toggleTemplate", { static: true }) private toggleTemplate: TemplateRef<any>;

  @ViewChild("accountConfirmTemplate", { static: true }) private accountConfirmTemplate: TemplateRef<any>;
  @ViewChild("accountInfoTemplate", { static: true }) private accountInfoTemplate: TemplateRef<any>;

  @ViewChild("meetingLogsTemplate", { static: true }) private meetingLogsTemplate: TemplateRef<any>;
  @ViewChild("usersTemplate", { static: true }) private usersTemplate: TemplateRef<any>;
  @ViewChild("usersToCreateRoomTemplate", { static: true }) private usersToCreateRoomTemplate: TemplateRef<any>;
  @ViewChild("roomsTemplate", { static: true }) private roomsTemplate: TemplateRef<any>;
  @ViewChild("uploadExcelTemplate", { static: true }) private uploadExcelTemplate: TemplateRef<any>;
  @ViewChild("resultsExcelTemplate", { static: true }) private resultsExcelTemplate: TemplateRef<any>;
  @ViewChild("successfullyDeployedTemplate", { static: true }) private successfullyDeployedTemplate: TemplateRef<any>;
  @ViewChild("failureDeployedTemplate", { static: true }) private failureDeployedTemplate: TemplateRef<any>;
  @ViewChild("archiveStoringTimeTemplate", { static: true }) private archiveStoringTimeTemplate: TemplateRef<any>;

  accountManagers = null;
  whitelabels = []
  whitelabelsSub: Subscription = null

  action: string;
  actionTitle: string = "";

  accountId: string;

  formPristine: boolean = true;
  formLoading: boolean = true;
  formValueSub: Subscription = null;

  passFormPristine: boolean = true;
  passFormValueSub: Subscription = null;

  archiveFormPristine: boolean = true;
  archiveFormValueSub: Subscription = null;

  accountsManagersSub: Subscription = null;

  orjAccount: any;
  account: any = {
    accountManager: null,
    whitelabel: environment.environmentName,
    accountName: "",
    companyName: "",
    disabled: false,
    licenseType: "expert_user_based",
    licenseModel: "ultimate",
    demo: true,
    ultimateTime: 0,
    licenseLimit: 0,
    licenseLimit2: 0,
    roomLimit: 0,
    expertConcurrentLimit: 0,
    remoteAccount: true,
    workflowAccount: false,
    remoteLicenseStartEnd: null,
    workflowLicenseStartEnd: null,
    workflowUserLimit: 0,
    workflowLimit: 0,
    workflowReportLimit: 0,
    filesStoringDays: 0,
    dedicatedArchive: 0,
    expireArchive: 0,
    password: "",
    confirmPassword: "",
    adminEmail: "",
    timezone: "UTC",
    features: {
      archiving: true,
      screensharing: true,
      reactions: true,
      snapshot: true,
      smartglass: true,
      arcollaboration: true,
      imagecollaboration: true,
      downloadimgcoll: true,
      pdfcollaboration: true,
      threedcollaboration: true,
      cameracontrols: true,
      batterystatus: true,
      filesharing: true,
      chattranslation: true,
      azureintegration: false,
      peertopeer: true,
      arplus: true,
      joinwithlink: true,
      twofactorauth: true,
      calling: true,
      weeklyreport: true,
      coadmin: true,
      schedulemeeting: true,
      roomfiles: true,
      adminreportcharts: true,
      workflowqr: true,
      workflowai: false
    },
    addOns: {
      workflowconnections: true,
      workflowsections: true,
      workflowremoteintegration: true,
      workorder: true,
      videoflow: true,
      aiassistant: false,
      nestedworkflows: true,
      mobiledeeplink: false,
      tubitakfeatures: false,
      trainingroom: false,
      sessionexport: true,
      sessionfilesaftersession: false,
      customsessionexportsubject: false,
      customserviceemail: false,
      webdav: false,
      cammicbypass: false,
      sso: false,
      fullhd: true,
      ticket: true,
      offlineticket: false,
      mandatoryticket: false,
      multiloginwarning: false,
      agreement: false,
      azureadintegration: false,
      workflowonremote: false,
      autojoinroom: false,
      coadminexpert: false,
      smssending: true,
      detailedvideoquality: true,
      dontkickinactives: false,
      roomfilesforsubs: false,
      webstatus: true,
      remotewebhooks: false,
      workflowwebhooks: false,
      autoguestname: true,
      skiptutorialforfields: true,
      showclientsessionrating: false,
      archiveoptimization: false,
      endmeetingforall: false,
      wipesessiondatabtn: false,
      twofactorauthexpert: false,
      personalroomlanding: false,
      invalidatemeetinglink: false,
      oidcsso: false,
      realtimetranslation: true,
    }
  };
  accountInTrial: boolean = false;

  passwordGroup = {
    password: "",
    confirmPassword: ""
  }

  archiveStorageData = null;

  archiveStorage = {
    dedicatedArchive2: 0,
    expireArchive2: 0
  }

  accountNames: Observable<any[]> = null;
  initialAzureStorageStatus = null;
  initialAzureStorageStatusSub: Subscription = null;

  activeUsers: any = null;
  activeUsersSub: Subscription = null;

  excelUploadUsers: any[] = [];
  isAnyError: boolean = false;
  fileUploaded: boolean = false;
  repeatedUsers = [];
  excelUserUploadError: string = '';
  uploadedFile: File = null;
  uploadExcelFileTemplateId: number = 0;

  starterFeatures = ['snapshot', 'imagecollaboration', 'downloadimgcoll', 'pdfcollaboration', 'arcollaboration', 'filesharing', 'reactions', 'joinwithlink', 'weeklyreport'];

  professionalFeatures = ['snapshot', 'imagecollaboration', 'downloadimgcoll', 'pdfcollaboration', 'arcollaboration', 'filesharing', 'reactions', 'joinwithlink', 'weeklyreport',
    'screensharing', 'smartglass', 'threedcollaboration', 'chattranslation', 'cameracontrols', 'batterystatus', 'schedulemeeting', 'roomfiles'];

  workflowFeatures = ['workflowqr', 'workflowai'];

  autoCreateRoomUsers: boolean = true;

  adminMail: string = null;
  emailRecipients: any[] = [];
  recipientsChanged: boolean = false;
  validMailValidator = Validators.pattern(/^$|^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,})+$/);
  validMailValidatorLong = Validators.pattern(/^$|^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,})+$/);

  creationEmailRecipients: any[] = [];
  creationEmailRecipientsChanged: boolean = false;

  timezones: string[] = ["UTC-12", "UTC-11", "UTC-10", "UTC-9", "UTC-8", "UTC-7", "UTC-6", "UTC-5", "UTC-4", "UTC-3", "UTC-2", "UTC-1",
    "UTC", "UTC+1", "UTC+2", "UTC+3", "UTC+4", "UTC+5", "UTC+6", "UTC+7", "UTC+8", "UTC+9", "UTC+10", "UTC+11", "UTC+12", "UTC+13", "UTC+14"];

  trainingLicensesForm: any = new FormGroup({ licenses: new FormArray([]) });
  trainingLicenses: {id:string,name:string,publisher:number,concurrent:number,time:number,notify_threshold:number,prevent_join:boolean,time_usage:number}[] = [];

  trainingLicensesFormPristine = true;

  smsLicense = { limit: 0, notify_threshold: 0, prevent_send: true, usage: 0 };
  orjSmsLicense = null;
  smsFormPristine = true;

  workflowUsers: AccountWorkflowUsers
  workflows: AccountWorkflows
  workflowReports: AccountWorkflowReports

  // Child accounts for organization hierarchy
  selectedChildAccounts: string[] = [];
  availableChildAccounts: Account[] = [];
  originalChildAccounts: string[] = [];

  startThreshold: number;
  endThreshold: number;
  licenseDateThresholdsSub: Subscription = null

  // Demo workflow copy functionality
  accounts: any[] = [];
  selectedDemoAccount: string = null;
  selectedDemoWorkflow: string = null;
  availableWorkflows: any[] = [];
  loadingWorkflows: boolean = false;

  constructor(
    private afdb: AngularFireDatabase,
    private accountService: AccountService,
    private detailPageService: DetailPageService,
    private changeDetector: ChangeDetectorRef,
    private translateService: TranslateService,
    private flashMessages: FlashMessagesService,
    private loaderService: LoaderService,
    private modalService: ModalService
  ) { }

  showFeatureInfo(event: PointerEvent, name: string) {
    event.stopPropagation();
    event.preventDefault();
    this.showInfoModal("features", name)
  }

  showAddOnInfo(event: PointerEvent, name: string) {
    event.stopPropagation();
    event.preventDefault();
    this.showInfoModal("addons", name)
  }

  showInfoModal(type: string, name: string) {
    if (!infoImages[name]) {
      this.flashMessages.show("Info not available.", { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
      return;
    }

    const modalId = this.modalService.show({
      template: this.featureAddOnInfoModal,
      context: {
        dataModel: {
          type: type,
          name: name,
          index: 0,
          data: infoImages[name]
        },
        callbacks: {
          close: () => this.modalService.hide(modalId),
        }
      }
    });
  }

  copyDemoWorkflow(name: string) {
    this.loaderService.show()
    this.accountService.copyDemoWorkflow(this.accountId, name).then(result => {
      if (result.data.exists) {
        this.flashMessages.show("Demo workflow updated as a new version.", { cssClass: 'alert-success', timeout: 4000, closeOnClick: true })
      } else {
        this.flashMessages.show("Demo workflow copied for the first time.", { cssClass: 'alert-success', timeout: 4000, closeOnClick: true })
      }
    })
    .catch(error => {
      console.log(error)

      if (error instanceof HttpErrorResponse) {
        if (error.error === "source-workflow-not-found") {
          this.flashMessages.show("Source workflow not found.", { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
        } else if (error.error === 'workflow-already-exists') {
          this.flashMessages.show("Workflow already exists in target account.", { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
        }
      } else {
        this.flashMessages.show("An error occurred.", { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
      }
    })
    .finally(() => this.loaderService.hide())
  }

  onDemoAccountChange(accountId: string) {
    this.selectedDemoAccount = accountId;
    this.selectedDemoWorkflow = null;
    this.availableWorkflows = [];

    if (accountId) {
      this.loadingWorkflows = true;
      this.accountService.getAllWorkflows(accountId)
        .then(response => {
          const workflowList = response.data.workflowList || [];

          this.availableWorkflows = workflowList
          .filter(workflow => workflow.published)
          .map(workflow => {
            const result: any = { id: workflow.id, name: "" };
            if (workflow.published) {
              if (workflow.published.translations && workflow.published.defaultLanguage) {
                result.name = workflow.published.translations[workflow.published.defaultLanguage][workflow.published.name]
              } else {
                result.name = workflow.published.name;
              }
            }
            return result;
          });
        })
        .catch(error => {
          console.error('Error loading workflows:', error);
          this.flashMessages.show('Error loading workflows.', { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
          this.availableWorkflows = [];
        })
        .finally(() => {
          this.loadingWorkflows = false;
        });
    }
  }

  onDemoWorkflowChange(workflowId: string) {
    this.selectedDemoWorkflow = workflowId;
  }

  copySelectedDemoWorkflow() {
    if (!this.selectedDemoAccount || !this.selectedDemoWorkflow) {
      this.flashMessages.show('Please select both account and workflow.', { cssClass: 'alert-warning', timeout: 4000, closeOnClick: true });
      return;
    }

    this.loaderService.show();
    // Use the copyDemoWorkflow service method with custom source account and workflow parameters
    this.accountService.copyDemoWorkflow(this.accountId, 'custom', this.selectedDemoAccount, this.selectedDemoWorkflow)
      .then(result => {
        if (result.data && result.data.exists) {
          this.flashMessages.show('Workflow updated as a new version.', { cssClass: 'alert-success', timeout: 4000, closeOnClick: true });
        } else {
          this.flashMessages.show('Workflow copied successfully.', { cssClass: 'alert-success', timeout: 4000, closeOnClick: true });
        }
      })
      .catch(error => {
        console.error('Error copying workflow:', error);
        if (error instanceof HttpErrorResponse) {
          if (error.error === "source-workflow-not-found") {
            this.flashMessages.show("Selected workflow not found.", { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
          } else if (error.error === 'workflow-already-exists') {
            this.flashMessages.show("Workflow already exists in target account.", { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
          } else {
            this.flashMessages.show('Error copying workflow.', { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
          }
        } else {
          this.flashMessages.show('Error copying workflow.', { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
        }
      })
      .finally(() => {
        this.loaderService.hide();
      });
  }

  addTrainingLicense() {
    this.createTrainingLicense("New License", 0, 0, 0, 0, true, 0, this.afdb.createPushId());
  }

  onListLoginAttempts() {
    const dataModel = { attempts: [] };
    const modalId = this.modalService.show({
      template: this.loginAttemptsTemplate,
      context: {
        dataModel: dataModel,
        callbacks: {
          no: () => this.modalService.hide(modalId),
          load: () => {
            if (dataModel.attempts.length > 0) {
              this.get10Attempt(dataModel, dataModel.attempts[dataModel.attempts.length-1]);
            }
          }
        }
      }
    });

    this.afdb.list(`login_attempts/${this.account.accountName}`).query.orderByKey().limitToLast(10).once("value")
    .then(result => {
      const obj = result.val();
      const ids = result.exists() ? Object.keys(obj) : [];

      for (const id of ids) {
        const attmp = obj[id];
        attmp.id = id;
        attmp.date = new Date(attmp.create_time).toLocaleString("tr");
        dataModel.attempts.unshift(attmp);
      }
    });
  }

  get10Attempt(dataModel, prevSession) {
    this.afdb.list(`login_attempts/${this.account.accountName}`).query.orderByKey().endAt(prevSession.id).limitToLast(11).once("value")
    .then(result => {
      const obj = result.val();
      const ids = result.exists() ? Object.keys(obj).reverse() : [];
      ids.shift();

      for (const id of ids) {
        const attmp = obj[id];
        attmp.id = id;
        attmp.date = new Date(attmp.create_time).toLocaleString("tr");
        dataModel.attempts.push(attmp);
      }
    });
  }

  showKickReasons(session) {
    const dataModel = { reasons: session.kickRoomReasons };
    const modalId = this.modalService.show({
      template: this.kickReasonsTemplate,
      context: {
        dataModel: dataModel,
        callbacks: {
          close: () => this.modalService.hide(modalId)
        }
      }
    });
  }

  onMeetingLogs() {
    const dataModel = { meetings: [], noLog: false };
    const modalId = this.modalService.show({
      template: this.meetingLogsTemplate,
      context: {
        dataModel: dataModel,
        callbacks: {
          no: () => this.modalService.hide(modalId)
        }
      }
    });

    this.afdb.object<any>(`accounts/${this.accountId}/meeting_logs`).valueChanges().pipe(first()).toPromise()
    .then(result => {
      if (result) {
        dataModel.meetings = Object.keys(result).map(id => result[id]);
      } else {
        dataModel.noLog = true;
      }
    })
  }

  onListSessions() {
    const dataModel = { sessions: [] };
    const modalId = this.modalService.show({
      template: this.sessionsTemplate,
      context: {
        dataModel: dataModel,
        callbacks: {
          no: () => this.modalService.hide(modalId),
          load: () => {
            if (dataModel.sessions.length > 0) {
              this.get10Session(dataModel, dataModel.sessions[dataModel.sessions.length-1]);
            }
          },
          reloadExports: (session) => {
            this.afdb.list<any>(`accounts/${this.accountId}/sessions_meta/${session.id}/exports`).valueChanges(["child_added"]).pipe(first()).toPromise()
            .then(e => session.exports = e.map(ex => {
              ex.date = new Date(ex.create_time).toLocaleString("tr", {timeZoneName: "short"});
              return ex;
            }));
          },
          resend: (session, exportData) => this.showResendExportModal(session, exportData),
          showKickReasons: (session) => this.showKickReasons(session)
        }
      }
    });

    this.afdb.list(`accounts/${this.accountId}/all_sessions`).query.orderByKey().limitToLast(10).once("value")
    .then(result => {
      const obj = result.val();
      const ids = result.exists() ? Object.keys(obj) : [];

      for (const id of ids) {
        const ses = obj[id];
        ses.id = id;
        ses.date = new Date(ses.create_time).toLocaleString("tr", {timeZoneName: "short"});
        ses.duration = (ses.start_time && ses.end_time) ? (ses.end_time - ses.start_time) : null;
        ses.exports = [];
        ses.kickRoomReasons = [];
        dataModel.sessions.unshift(ses);

        this.afdb.list<any>(`accounts/${this.accountId}/sessions_meta/${id}/exports`).valueChanges(["child_added"]).pipe(first()).toPromise()
        .then(e => ses.exports = e.map(ex => {
          ex.date = new Date(ex.create_time).toLocaleString("tr", {timeZoneName: "short"});
          return ex;
        }));

        this.afdb.list<any>(`accounts/${this.accountId}/sessions/${ses.room_id}/${ses.id}/kick_room_reasons`).valueChanges(["child_added"]).pipe(first()).toPromise()
        .then(reasons => ses.kickRoomReasons = reasons.map(r => {
          r.date = new Date(r.create_time).toLocaleString("tr", {timeZoneName: "short"});
          return r;
        }));
      }
    });
  }

  async uploadFiles(event) {
    const upFile: FileList = event.target.files;
    this.fileUploaded = false;

    const uploadedFile = upFile.item(0);
    const xlsxFileType = uploadedFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    if (xlsxFileType) {  
      this.fileUploaded = true;
      this.uploadedFile = uploadedFile;
    } else {
      this.fileUploaded = false;
      this.uploadedFile = null;
    }  
  }

  importUsers() {
    let sameUsernameError: string = '';
    let sameUsernamePreRegistered: string = '';
    let fillNecessaryFields: string = '';
    let expertLimitExceeded: string = '';
    let dontUseDotsForUsername: string = '';
    let wrongBooleanFormat: string = '';

    sameUsernameError = this.translateService.instant('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.USER_LIST.SAME_USERNAME');
    sameUsernamePreRegistered = this.translateService.instant('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.USER_LIST.SAME_USERNAME_PRE_REGISTERED');
    fillNecessaryFields = this.translateService.instant('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.USER_LIST.FILL_ALL_NECESSARY');
    expertLimitExceeded = this.translateService.instant('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.USER_LIST.EXPERT_LIMIT_EXCEEDED');
    dontUseDotsForUsername = this.translateService.instant('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.USER_LIST.PLEASE_DONT_USE_DOTS_FOR_USERNAME');
    wrongBooleanFormat = this.translateService.instant('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.USER_LIST.WRONG_BOOLEAN_FORMAT');
    
    const modalId = this.modalService.show({
      template: this.uploadExcelTemplate,
      context: {
        dataModel: null,
        callbacks: {
          cancel: () => {
            this.fileUploaded = false;
            this.modalService.hide(modalId);
            this.uploadExcelFileTemplateId = modalId;
          },
          importFile: async () => {
            this.uploadExcelFileTemplateId = modalId;

            this.excelUploadUsers = [];
            this.repeatedUsers = [];

            this.isAnyError = false;

            this.loaderService.show();
            this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.USER_LIST.PLEASE_WAIT').toPromise().then(result => this.flashMessages.show(result, { cssClass: 'alert-info', timeout: 4000, closeOnClick: true }));

            const formData = new FormData();
            await formData.append("file", this.uploadedFile);
            
            try {
              const response = await this.accountService.importUsersConfirm(this.accountId, this.account.account_name, formData);

              const checkResult = response ? response.check_result : null;
              const sameUsernamesInExcelList = response ? response.duplicated_usernames_in_excel_table : null;
              const sameUsernamesPreregistered = response ? response.repeated_users_registered_before : null;

              if (checkResult) {
                this.setExcelUserUploadArray(response);
                if (sameUsernamesInExcelList ? sameUsernamesInExcelList.length > 0 : false) {
                  this.setErrorMessage(sameUsernameError, sameUsernamesInExcelList);
                  this.closeModal(this.uploadExcelFileTemplateId);
                  this.openFailureDeploymentModal();
                } else if (sameUsernamesPreregistered ? sameUsernamesPreregistered.length > 0 : false) {
                  this.setErrorMessage(sameUsernamePreRegistered, sameUsernamesPreregistered);
                  this.closeModal(this.uploadExcelFileTemplateId);
                  this.openFailureDeploymentModal();
                } else {
                  this.closeModal(modalId);
                  this.openUploadConfirmationModal();
                }
              }
            } catch (error) {
              this.isAnyError = true;

              if (error.error === 'wrong-username-format') {
                this.setErrorMessage(dontUseDotsForUsername, null);  
                this.loaderService.hide();
                this.modalService.hide(modalId);
                this.openFailureDeploymentModal();
              } else if (error.error === 'wrong-boolean-format') {
                this.setErrorMessage(wrongBooleanFormat, null);
                this.loaderService.hide();
                this.modalService.hide(modalId);  
                this.openFailureDeploymentModal();
              } else if (error.error === 'some-fields-missing') {
                this.setErrorMessage(fillNecessaryFields, null);         
                this.loaderService.hide();
                this.modalService.hide(modalId);  
                this.openFailureDeploymentModal();
              } else if (error.error === 'expert-limit-reached') {
                this.setErrorMessage(expertLimitExceeded, null);    
                this.loaderService.hide();
                this.modalService.hide(modalId);
                this.openFailureDeploymentModal();
              } else {
                this.setErrorMessage('An error occurred during file upload', []);
                this.loaderService.hide();
                this.modalService.hide(modalId);
                this.openFailureDeploymentModal();
              }
            }
          }
        }
      }
    });
    this.uploadedFile = null;
  }

  setExcelUserUploadArray(response: any) {
    const userListSize = Object.keys(response.check_result).length;
    for (let i=0; i<userListSize; i++) {
      const excelUploadUser = response.check_result[i];
      this.excelUploadUsers.push(excelUploadUser);
      
      Object.values(excelUploadUser).every(val => {
        const user: any = val;
        if (user.hasError === true) {
          this.isAnyError = true;
          return false;
        }
        return true;
      });
    }
  }

  setErrorMessage(error: string, messageToModal: any) {
    this.excelUserUploadError = error;
    this.repeatedUsers = messageToModal;
  }

  closeModal(modalId: number) {
    this.loaderService.hide();
    this.modalService.hide(modalId);
  }

  openFailureDeploymentModal() {
    this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.USER_LIST.PROBLEMS_OCCURRED').toPromise().then(result => this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true }));

    const modalId = this.modalService.show({
      template: this.failureDeployedTemplate,
      context: {
        dataModel: null,
        callbacks: {
          close: () => {
            this.fileUploaded = false;
            this.modalService.hide(modalId);
          }
        }
      }
    });
  }

  openUploadConfirmationModal() {
    let successfullyAdded: string = '';
    let userCouldNotBeAdded: string = '';
    
    successfullyAdded = this.translateService.instant('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.USER_LIST.SUCCESSFULLY_ADDED');
    userCouldNotBeAdded = this.translateService.instant('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.USER_LIST.USER_COULD_NOT_BE_ADDED');

    const modalId = this.modalService.show({
      template: this.resultsExcelTemplate,
      context: {
        dataModel: null,
        callbacks: {
          cancel: () => {
            this.excelUploadUsers = [];
            this.fileUploaded = false;
            this.modalService.hide(modalId);

            this.importUsers();
          },
          importUsers: async () => {
            this.modalService.hide(this.uploadExcelFileTemplateId);
            this.isAnyError = false;
            this.loaderService.show();
            this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.USER_LIST.PLEASE_WAIT').toPromise().then(result => this.flashMessages.show(result, { cssClass: 'alert-info', timeout: 4000, closeOnClick: true }));
            this.modalService.hide(modalId);
            
            try {
              this.accountService.importUsers(this.accountId, this.excelUploadUsers)
              .then(response => {
                const failed_users_indices_length = response.failed_users_indices ? response.failed_users_indices.length : 0;
                if (failed_users_indices_length > 0) {
                  this.isAnyError = true;

                  this.translateService.get('APP.MAIN.USERS.USER_LIST.PROBLEMS_OCCURRED').toPromise().then(result => this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true }));

                  for (let i=0; i<failed_users_indices_length; i++) { 
                    this.excelUploadUsers[response.failed_users_indices[i]].err = userCouldNotBeAdded;
                  }
                  const succeeded_users_indices_length = response.succeeded_users_indices ? response.succeeded_users_indices.length : 0;
                  for (let i=0; i<succeeded_users_indices_length; i++) { 
                    this.excelUploadUsers[response.succeeded_users_indices[i]].success = successfullyAdded;
                  }
  
                  this.loaderService.hide();
                  this.openUploadConfirmationModal();
                } else {
                  this.loaderService.hide();
                  this.successfullyDeployedModal();
                }
              })
            } catch (error) {
              this.setErrorMessage('An error occurred during user import', []);
              this.loaderService.hide();
              this.openFailureDeploymentModal();
            }
          }
        }
      }
    });
  }

  successfullyDeployedModal() {
    this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.USER_LIST.SUCCESSFULLY_ADDED').toPromise().then(result => this.flashMessages.show(result, { cssClass: 'alert-success', timeout: 4000, closeOnClick: true }));

    const modalId = this.modalService.show({
      template: this.successfullyDeployedTemplate,
      context: {
        dataModel: null,
        callbacks: {
          close: () => {
            this.fileUploaded = false;

            this.modalService.hide(modalId);
          }
        }
      }
    });
  }

  onUsers() {
    const dataModel = { users: [], noUsers: false, disabledCount: 0 };
    const modalId = this.modalService.show({
      template: this.usersTemplate,
      context: {
        dataModel: dataModel,
        callbacks: {
          no: () => this.modalService.hide(modalId)
        }
      }
    });

    this.afdb.object<any>(`accounts/${this.accountId}/users`).valueChanges().pipe(first()).toPromise()
    .then(result => {
      if (result) {
        dataModel.users = Object.keys(result)
          .map(id => {
            if (result[id].auth && result[id].auth.disabled) {
              dataModel.disabledCount = dataModel.disabledCount + 1;
            }
            return { id, ...result[id] };
          })
          .filter(user => !user.guest && (user.auth ? !user.auth.deleted : false))
          .sort((a, b) => (a.name).localeCompare(b.name));
      } else {
        dataModel.noUsers = true;
      }
    })
  }

  getRole(user: any): string  {
    if (user.coadmin) {
      return "Co-Admin";
    }
    switch (user.role) {
      case "admin":
        return "Admin";
      case "coadmin":
        return "Co-Admin";
      case "expert":
        return "Expert";
      case "user":
        return "Subscriber";
      default:
        return "Subscriber";
    }
  }

  getUsersByRole(users: any[], role: string): any[] {
    return users.filter(user => {
      if (role === 'coadmin') {
        return user.coadmin || user.role === 'coadmin';
      }
      if (role === 'user') {
        return !user.role || user.role === 'user';
      }
      return user.role === role;
    });
  }

  getRoomsByType(rooms: any[], type: string): any[] {
    return rooms.filter(room => {
      const roomData = room.room_data;
      if (!roomData) return false;
      
      switch (type) {
        case 'training':
          return roomData.training_room === true;
        case 'meeting':
          return roomData.meeting_room !== undefined && roomData.meeting_room !== null;
        case 'personal':
          return roomData.personal_room !== undefined && roomData.personal_room !== null;
        case 'peer_to_peer':
          return roomData.peer_to_peer === true;
        default:
          return false;
      }
    });
  }

  onRooms() {
    const dataModel = { rooms: [], noRooms: false, disabledCount: 0 };
    const modalId = this.modalService.show({
      template: this.roomsTemplate,
      context: {
        dataModel: dataModel,
        callbacks: {
          no: () => this.modalService.hide(modalId)
        }
      }
    });

    this.afdb.object<any>(`accounts/${this.accountId}/rooms`).valueChanges().pipe(first()).toPromise()
    .then(result => {
      if (result) {
        dataModel.rooms = Object.keys(result)
          .map(id => {
            if (result[id].room_data && result[id].room_data.disabled) {
              dataModel.disabledCount = dataModel.disabledCount + 1;
            }
            return { id, room_data: result[id].room_data };
          })
          .filter(room => room.room_data ? !room.room_data.deleted : false)
          .sort((a, b) => (a.room_data ? a.room_data.name : '').localeCompare(b.room_data ? b.room_data.name : ''));
      } else {
        dataModel.noRooms = true;
      }
    })
  }

  async createClaroRooms(action: "check" | "create") {
    this.loaderService.show();
    this.accountService.createClaroRooms(this.accountId, action)
    .then(response => {

      this.loaderService.hide();
      if (action === "check") {
        const dataModel = { users: response.users, noUsers: response.users.length === 0, created: false };
        const modalId = this.modalService.show({
          template: this.usersToCreateRoomTemplate,
          context: {
            dataModel: dataModel,
            callbacks: {
              no: () => this.modalService.hide(modalId),
              proceed: () => {
                this.modalService.hide(modalId);
                this.createClaroRooms("create");
              }
            }
          }
        });
      } else if (action === "create") {
        const dataModel = { users: response.users, noUsers: response.users.length === 0, created: true };
        const modalId = this.modalService.show({
          template: this.usersToCreateRoomTemplate,
          context: {
            dataModel: dataModel,
            callbacks: {
              no: () => this.modalService.hide(modalId)
            }
          }
        });
      }
    })
    .catch(error => {
      console.log(error.error);
      this.loaderService.hide();
      if (error.error.message === "no-archive-optimization") {
        this.flashMessages.show("Please activate archive cost optimization add-on first.", { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
      } else if (error.error.message === "no-archiving") {
        this.flashMessages.show("Please activate archiving feature first.", { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
      } else if (error.error.message === "no-full-hd") {
        this.flashMessages.show("Please activate mobile full-hd add-on first.", { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
      } else {
        this.flashMessages.show("An error occurred while creating rooms.", { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
      }
    });
  }

  showResendExportModal(session: any, exportData: any) {
    const modalId = this.modalService.show({
      template: this.resendExportTemplate,
      context: {
        dataModel: null,
        callbacks: {
          close: () => this.modalService.hide(modalId),
          send: () => {
            this.loaderService.show();
            this.accountService.resendSessionExport(this.accountId, session.room_id, session.id, exportData.recipients)
            .then(() => {
              this.modalService.hide(modalId);
              this.flashMessages.show("Session export sent.", { cssClass: 'alert-success', timeout: 4000, closeOnClick: true });
            })
            .catch(error => this.flashMessages.show("Cannot send session export.", { cssClass: 'alert-danger', timeout: 6000, closeOnClick: true }))
            .finally(() => this.loaderService.hide());
          }
        }
      }
    });
  }

  get10Session(dataModel, prevSession) {
    this.afdb.list(`accounts/${this.accountId}/all_sessions`).query.orderByKey().endAt(prevSession.id).limitToLast(11).once("value")
    .then(result => {
      const obj = result.val();
      const ids = result.exists() ? Object.keys(obj).reverse() : [];
      ids.shift();

      for (const id of ids) {
        const ses = obj[id];
        ses.id = id;
        ses.date = new Date(ses.create_time).toLocaleString("tr", {timeZoneName: "short"});
        ses.duration = (ses.start_time && ses.end_time) ? (ses.end_time - ses.start_time) : null;
        ses.exports = [];
        ses.kickRoomReasons = [];
        dataModel.sessions.push(ses);

        this.afdb.list<any>(`accounts/${this.accountId}/sessions_meta/${id}/exports`).valueChanges(["child_added"]).pipe(first()).toPromise()
        .then(e => ses.exports = e.map(ex => {
          ex.date = new Date(ex.create_time).toLocaleString("tr", {timeZoneName: "short"});
          return ex;
        }));

        this.afdb.list<any>(`accounts/${this.accountId}/sessions/${ses.room_id}/${ses.id}/kick_room_reasons`).valueChanges(["child_added"]).pipe(first()).toPromise()
        .then(reasons => ses.kickRoomReasons = reasons.map(r => {
          r.date = new Date(r.create_time).toLocaleString("tr", {timeZoneName: "short"});
          return r;
        }));
      }
    });
  }

  createTrainingLicense(name: string, publisher: number, concurent: number, time: number, notify_threshold:number, prevent_join: boolean, time_usage: number, id: string) {
    const fg = new FormGroup({
      name: new FormControl(name, [Validators.required]),
      publisher: new FormControl(publisher, [Validators.required, Validators.min(0)]),
      concurrent: new FormControl(concurent, [Validators.required, Validators.min(0)]),
      time: new FormControl(time, [Validators.required, Validators.min(0)]),
      prevent_join: new FormControl(prevent_join),
      notify_threshold: new FormControl(notify_threshold, [Validators.required, Validators.min(0)]),
      time_usage: new FormControl(time_usage, [Validators.required, Validators.min(0)]),
      id: new FormControl(id)
    });
    (this.trainingLicensesForm.controls.licenses as FormArray).push(fg);
  }

  deleteTrainingLicense(index: number) {
    (this.trainingLicensesForm.controls.licenses as FormArray).removeAt(index);
  }

  resetTrainingLicensesForm() {
    (this.trainingLicensesForm.controls.licenses as FormArray).clear();
    this.trainingLicenses.forEach(license => this.createTrainingLicense(license.name, license.publisher, license.concurrent, license.time, license.notify_threshold, license.prevent_join, license.time_usage, license.id));
  }

  resetSmsForm() {
    this.smsLicense.limit = this.orjSmsLicense.limit;
    this.smsLicense.usage = this.orjSmsLicense.usage;
    this.smsLicense.notify_threshold = this.orjSmsLicense.notify_threshold;
    this.smsLicense.prevent_send = this.orjSmsLicense.prevent_send;
  }

  refreshLicenseDateThresholds() {
    const now = (new Date()).getTime()
    this.startThreshold = now + UtilityService.timezoneOffset + 1000*60*60*12;
    this.endThreshold = now + UtilityService.timezoneOffset - 1000*60*60*12;
  }

  ngOnInit() {
    this.refreshLicenseDateThresholds()
    this.licenseDateThresholdsSub = interval(1000).subscribe(() => this.refreshLicenseDateThresholds())

    this.accountsManagersSub = this.accountService.accountsManagers
    .subscribe(managers => { this.accountManagers = managers; });

    this.whitelabelsSub = this.afdb.object<any>("whitelabels").valueChanges()
    .subscribe(whitelabelsObj => {
      const whitelabelIds = whitelabelsObj ? Object.keys(whitelabelsObj) : []
      this.whitelabels = whitelabelIds
        .map(wid => {
          const w = whitelabelsObj[wid]
          w.id = wid
          return w
        })
        .sort((a,b) => a.name.localeCompare(b.name))
        .sort((a,b) => {
          return a.ended ? 1 : (b.ended ? -1 : (b.env === environment.environmentName ? 1 : (a.env === environment.environmentName ? -1 : 1)))
        });
    });

    if (this.action === this.ACTION_NEW) {
      this.orjAccount = {
        accountManager: null,
        whitelabel: environment.environmentName,
        accountName: "",
        companyName: "",
        licenseType: "expert_user_based",
        licenseModel: "ultimate",
        demo: true,
        ultimateTime: 0,
        licenseLimit: 0,
        licenseLimit2: 0,
        roomLimit: 0,
        expertConcurrentLimit: 0,
        remoteAccount: true,
        workflowAccount: false,
        remoteLicenseStartEnd: null,
        workflowLicenseStartEnd: null,
        workflowUserLimit: 0,
        workflowLimit: 0,
        workflowReportLimit: 0,
        filesStoringDays: 0,
        dedicatedArchive: 0,
        expireArchive: 0,
        password: "",
        confirmPassword: "",
        adminEmail: "",
        timezone: "UTC",
        features: {
          archiving: true,
          screensharing: true,
          reactions: true,
          snapshot: true,
          smartglass: true,
          arcollaboration: true,
          imagecollaboration: true,
          downloadimgcoll: true,
          pdfcollaboration: true,
          threedcollaboration: true,
          cameracontrols: true,
          batterystatus: true,
          filesharing: true,
          chattranslation: true,
          azureintegration: false,
          peertopeer: true,
          arplus: true,
          joinwithlink: true,
          twofactorauth: true,
          calling: true,
          weeklyreport: true,
          coadmin: true,
          schedulemeeting: true,
          roomfiles: true,
          adminreportcharts: true,
          workflowqr: false,
          workflowai: false
        },
        addOns: {
          workflowconnections: true,
          workflowsections: true,
          workflowremoteintegration: true,
          workorder: true,
          videoflow: true,
          aiassistant: false,
          nestedworkflows: true,
          mobiledeeplink: false,
          tubitakfeatures: false,
          trainingroom: false,
          sessionexport: true,
          sessionfilesaftersession: false,
          customsessionexportsubject: false,
          customserviceemail: false,
          webdav: false,
          cammicbypass: false,
          sso: false,
          fullhd: true,
          ticket: true,
          offlineticket: false,
          mandatoryticket: false,
          multiloginwarning: false,
          agreement: false,
          azureadintegration: false,
          workflowonremote: false,
          autojoinroom: false,
          coadminexpert: false,
          smssending: true,
          detailedvideoquality: true,
          dontkickinactives: false,
          roomfilesforsubs: false,
          webstatus: true,
          remotewebhooks: false,
          workflowwebhooks: false,
          autoguestname: true,
          skiptutorialforfields: true,
          showclientsessionrating: false,
          archiveoptimization: false,
          endmeetingforall: false,
          wipesessiondatabtn: false,
          twofactorauthexpert: false,
          personalroomlanding: false,
          invalidatemeetinglink: false,
          oidcsso: false,
          realtimetranslation: true,
        }
      };
      this.accountNames = this.accountService.accountsMeta
      .pipe(map(meta => meta.map(account => account.account_name)));
      this.formLoading = false;
      this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.TITLE_NEW').toPromise()
      .then(result => { this.actionTitle = result; });
    } else {
      if (this.action === this.ACTION_DETAILS) {
        this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.TITLE_DETAILS').toPromise()
        .then(result => { this.actionTitle = result; });
      } else if  (this.action === this.ACTION_EDIT) {
        this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.TITLE_EDIT').toPromise()
        .then(result => { this.actionTitle = result; });
      }

      this.passFormValueSub = this.passwordForm.valueChanges.subscribe(value => {
        if (value.password !== "" || value.confirmPassword !== "") {
          this.passFormPristine = false
        } else {
          this.passFormPristine = true
        }
      });

      this.archiveFormValueSub = this.archiveForm.valueChanges.subscribe(value => {
        let pristine = true;

        if (this.archiveStorageData) {
          if (this.archiveStorageData.limits.dedicated !== value.dedicatedArchive2) {
            pristine = false;
          }
          if (this.archiveStorageData.limits.expire !== value.expireArchive2) {
            pristine = false;
          }
        }
        
        this.archiveFormPristine = pristine;
      });

      this.loadAccountData();
    }

    this.formValueSub = this.accountForm.valueChanges.subscribe(value => {
      let pristine = true;
      if (this.orjAccount) {
        Object.keys(this.orjAccount).filter(x => (x !== "remoteLicenseStartEnd" && x !== "workflowLicenseStartEnd" && x !== "password" && x !== "confirmPassword" && x !== "features" && x !== "addOns")).forEach(property => {
          if (this.accountForm.controls[property] && !this.accountForm.controls[property].disabled && value[property] !== this.orjAccount[property]) {
            pristine = false;
          }
        });
        Object.keys(this.orjAccount.features).forEach(key => {
          if (value[key] !== this.orjAccount.features[key]) {
            pristine = false;
          }
        });
        Object.keys(this.orjAccount.addOns).forEach(key => {
          if (value[key] !== this.orjAccount.addOns[key]) {
            pristine = false;
          }
        });
      }

      if (value.remoteLicenseStartEnd) {
        value.remoteLicenseStartEnd[0].setHours(0, 0, 0, 0)
        value.remoteLicenseStartEnd[1].setHours(23, 59, 59, 999)

        if (this.orjAccount.remoteLicenseStartEnd) {
          value.remoteLicenseStartEnd.forEach((date, index) => {
            if (date.getTime() !== this.orjAccount.remoteLicenseStartEnd[index].getTime()) {
              pristine = false;
            }
          })
        } else {
          pristine = false;
        }
      } else if (this.orjAccount.remoteLicenseStartEnd) {
        pristine = false;
      }
      if (value.workflowLicenseStartEnd) {
        value.workflowLicenseStartEnd[0].setHours(0, 0, 0, 0)
        value.workflowLicenseStartEnd[1].setHours(23, 59, 59, 999)

        if (this.orjAccount.workflowLicenseStartEnd) {
          value.workflowLicenseStartEnd.forEach((date, index) => {
            if (date.getTime() !== this.orjAccount.workflowLicenseStartEnd[index].getTime()) {
              pristine = false;
            }
          })
        } else {
          pristine = false;
        }
      } else if (this.orjAccount.workflowLicenseStartEnd) {
        pristine = false;
      }
      this.formPristine = pristine;
    });

    this.trainingLicensesForm.valueChanges.subscribe(value => {
      let pristine = value.licenses.every(blicense => {
        const ab = this.trainingLicenses.find(b => b.id === blicense.id);
        return ab ? ab.name === blicense.name && ab.publisher === blicense.publisher && ab.concurrent === blicense.concurrent && ab.time === blicense.time && ab.notify_threshold === blicense.notify_threshold && ab.prevent_join === blicense.prevent_join : false;
      });
      this.trainingLicensesFormPristine = pristine && this.trainingLicenses.every(blicense => {
        const ab = value.licenses.find(b => b.id === blicense.id);
        return ab ? ab.name === blicense.name && ab.publisher === blicense.publisher && ab.concurrent === blicense.concurrent && ab.time === blicense.time && ab.notify_threshold === blicense.notify_threshold && ab.prevent_join === blicense.prevent_join : false;
      });
    });

    this.smsForm.valueChanges.subscribe(value => {
      let pristine = true;
      if (this.orjSmsLicense) {
        if (this.orjSmsLicense.limit !== this.smsLicense.limit) {
          pristine = false;
        }
        if (this.orjSmsLicense.usage !== this.smsLicense.usage) {
          pristine = false;
        }
        if (this.orjSmsLicense.notify_threshold !== this.smsLicense.notify_threshold) {
          pristine = false;
        }
        if (this.orjSmsLicense.prevent_send !== value.preventSend) {
          pristine = false;
        }
      }
      this.smsFormPristine = pristine;
    });
  }

  ngAfterViewChecked() {
    if (this.action === this.ACTION_DETAILS) {
      this.accountForm.control.disable({ emitEvent: false });
      this.passwordForm.control.disable();
      this.archiveForm.control.disable();
    } else if (this.action === this.ACTION_EDIT) {
      if (this.accountForm.controls.accountName) {
        this.accountForm.controls.accountName.disable({ emitEvent: false })
      }
    }
    this.changeDetector.detectChanges();
  }

  getExactStartDateStr(date: Date) {
    return this.getLocalizedDateStr(new Date(date.getTime() - UtilityService.timezoneOffset - 1000*60*60*12))
  }

  getExactEndDateStr(date: Date) {
    return this.getLocalizedDateStr(new Date(date.getTime() - UtilityService.timezoneOffset + 1000*60*60*12))
  }

  getLocalizedDateStr(date: Date) {
    const browserLang = this.translateService.getBrowserLang();
    return date.toLocaleString(browserLang, { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric", timeZoneName: "short" })
  }

  loadAccountData() {
    this.activeUsersSub = this.accountService.accountsMeta.pipe(
      map(accs => {
        // Store all accounts for demo workflow copy functionality
        this.accounts = (accs || []).map(acc => { return { id: acc.id, name: acc.company_name + " (" + acc.account_name + ")" }; }).filter(a => a.id !== this.accountId);

        return accs.find(a => a.id === this.accountId);
      }),
      map(acc => { return (acc ? acc.active_users : null)}), 
      distinctUntilChanged()
    )
    .subscribe(active_users => {
      this.activeUsers = active_users;
    });

    this.accountService.getAzureStorageData(this.accountId)
    .then(azureData => {
      this.archiveStorageData = azureData;
      this.archiveStorage = { dedicatedArchive2: azureData.limits.dedicated, expireArchive2: azureData.limits.expire };
    });

    this.accountService.getAccount(this.accountId)
    .then(account => {
      this.accountNames = this.accountService.accountsMeta
      .pipe(map(meta => meta.filter(account => account.id !== this.accountId).map(account => account.account_name)));

      this.initialAzureStorageStatusSub = this.accountService.accountsMeta.pipe(map(accs => accs.find(acc => acc.id === this.accountId).initial_azure_storage_status))
      .subscribe(status => {
        this.initialAzureStorageStatus = status;
      })

      this.orjAccount = {
        accountManager: account.account_manager ? account.account_manager : null,
        whitelabel: account.whitelabel ? account.whitelabel : environment.environmentName,
        accountName: account.account_name,
        companyName: account.company_name,
        disabled: account.disabled,
        licenseType: account.license.type,
        licenseLimit: account.license.limit,
        licenseLimit2: isNaN(account.license.limit2) ? 0 : account.license.limit2,
        roomLimit: account.license.room_limit,
        expertConcurrentLimit: isNaN(account.license.expert_concurrent_limit) ? 0 : account.license.expert_concurrent_limit,
        remoteAccount: account.license.remote_account,
        workflowAccount: account.license.workflow_account,
        remoteLicenseStartEnd: account.license.remote_account ? [new Date(account.license.remote_start + UtilityService.timezoneOffset), new Date(account.license.remote_end + UtilityService.timezoneOffset)] : null,
        workflowLicenseStartEnd: account.license.workflow_account ? [new Date(account.license.workflow_start + UtilityService.timezoneOffset), new Date(account.license.workflow_end + UtilityService.timezoneOffset)] : null,
        workflowUserLimit: isNaN(account.license.workflow_user_limit) ? 0 : account.license.workflow_user_limit,
        workflowLimit: isNaN(account.license.workflow_limit) ? 0 : account.license.workflow_limit,
        workflowReportLimit: isNaN(account.license.workflow_report_limit) ? 0 : account.license.workflow_report_limit,
        filesStoringDays: isNaN(account.license.files_storing_days) ? 0 : account.license.files_storing_days,
        licenseModel: account.license.model ? account.license.model : "ultimate",
        demo: account.license.demo ? account.license.demo : false,
        ultimateTime: account.license.ultimate_time,
        adminEmail: account.admin ? account.admin.email : "",
        timezone: account.timezone ? account.timezone : "UTC",
        organization: account.organization ? account.organization : null
      };
      this.account = {
        accountManager: account.account_manager ? account.account_manager : null,
        whitelabel: account.whitelabel ? account.whitelabel : environment.environmentName,
        accountName: account.account_name,
        companyName: account.company_name,
        disabled: account.disabled,
        licenseType: account.license.type,
        licenseLimit: account.license.limit,
        licenseLimit2: isNaN(account.license.limit2) ? 0 : account.license.limit2,
        roomLimit: account.license.room_limit,
        expertConcurrentLimit: isNaN(account.license.expert_concurrent_limit) ? 0 : account.license.expert_concurrent_limit,
        remoteAccount: account.license.remote_account,
        workflowAccount: account.license.workflow_account,
        remoteLicenseStartEnd: account.license.remote_account ? [new Date(account.license.remote_start + UtilityService.timezoneOffset), new Date(account.license.remote_end + UtilityService.timezoneOffset)] : null,
        workflowLicenseStartEnd: account.license.workflow_account ? [new Date(account.license.workflow_start + UtilityService.timezoneOffset), new Date(account.license.workflow_end + UtilityService.timezoneOffset)] : null,
        workflowUserLimit: isNaN(account.license.workflow_user_limit) ? 0 : account.license.workflow_user_limit,
        workflowLimit: isNaN(account.license.workflow_limit) ? 0 : account.license.workflow_limit,
        workflowReportLimit: isNaN(account.license.workflow_report_limit) ? 0 : account.license.workflow_report_limit,
        filesStoringDays: isNaN(account.license.files_storing_days) ? 0 : account.license.files_storing_days,
        licenseModel: account.license.model ? account.license.model : "ultimate",
        demo: account.license.demo ? account.license.demo : false,
        ultimateTime: account.license.ultimate_time,
        adminEmail: account.admin ? account.admin.email : "",
        timezone: account.timezone ? account.timezone : "UTC"
      };
      this.orjAccount.features = {};
      this.account.features = {};
      this.orjAccount.addOns = { personalroomlanding: false };
      this.account.addOns = { personalroomlanding: false };

      if (account.license.ultimate_trial) {
        Object.keys(account.after_trial_features).forEach(f => {
          this.orjAccount.features[f] = account.after_trial_features[f];
          this.account.features[f] = account.after_trial_features[f];
        });
      } else {
        Object.keys(account.features).forEach(f => {
          this.orjAccount.features[f] = account.features[f];
          this.account.features[f] = account.features[f];
        });
      }
      Object.keys(account.add_ons).forEach(f => {
        this.orjAccount.addOns[f] = account.add_ons[f];
        this.account.addOns[f] = account.add_ons[f];
      });
      this.accountInTrial = account.license.ultimate_trial;
      this.emailRecipients = (account.email_recipients ? account.email_recipients : []).map(r => ({value: r, display: r}));

      this.trainingLicenses = account.training_licenses ? Object.keys(account.training_licenses).map(bid => {
        const t = account.training_licenses[bid];
        t.id = bid;
        t.prevent_join = t.prevent_join ? true : false;
        t.notify_threshold = t.notify_threshold ? t.notify_threshold : 0;
        return t;
      }) : [];
      this.trainingLicenses.forEach(license => this.createTrainingLicense(license.name, license.publisher, license.concurrent, license.time, license.notify_threshold, license.prevent_join, license.time_usage, license.id));

      if (account.sms_license) {
        this.smsLicense = {
          limit: account.sms_license.limit,
          notify_threshold: account.sms_license.notify_threshold,
          prevent_send: account.sms_license.prevent_send,
          usage: account.sms_license.usage
        }
        this.orjSmsLicense = {
          limit: account.sms_license.limit,
          notify_threshold: account.sms_license.notify_threshold,
          prevent_send: account.sms_license.prevent_send,
          usage: account.sms_license.usage
        }
      }
      this.workflowUsers = account.workflow_users;
      this.workflows = account.workflows;
      this.workflowReports = account.workflow_reports;
      this.formLoading = false;

      // Load available child accounts if not in new mode
      if (this.action !== this.ACTION_NEW) {
        this.loadAvailableChildAccounts();
      }
    });
  }

  // Load available accounts for child selection
  loadAvailableChildAccounts() {
    this.accountService.accountsMeta.pipe(first()).subscribe(accounts => {
      // Filter out: this account, accounts that already have a different parent
      // BUT include accounts that are already this account's children
      this.availableChildAccounts = accounts.filter(acc => {
        if (acc.id === this.accountId) return false;
        if (!acc.organization || !acc.organization.parent_account_id) return true;
        if (acc.organization.parent_account_id === this.accountId) return true;
        return false;
      });
      
      // Set initial selection from current children
      const currentChildren = (this.orjAccount && this.orjAccount.organization && this.orjAccount.organization.child_account_ids) ? this.orjAccount.organization.child_account_ids : [];
      this.originalChildAccounts = [...currentChildren];
      this.selectedChildAccounts = [...currentChildren];
    });
  }

  // Save child accounts selection
  saveChildAccounts() {
    const changes = {
      accountId: this.accountId,
      organization: {
        child_account_ids: this.selectedChildAccounts
      }
    };
    
    this.loaderService.show();
    this.accountService.updateAccount(changes)
      .then(() => {
        this.flashMessages.show('Child accounts updated.', { cssClass: 'alert-success', timeout: 4000 });
        this.originalChildAccounts = [...this.selectedChildAccounts];
        
        // Update orjAccount with new values
        if (!this.orjAccount.organization) {
          this.orjAccount.organization = {};
        }
        this.orjAccount.organization.child_account_ids = [...this.selectedChildAccounts];
      })
      .catch(err => {
        this.flashMessages.show('Failed to update child accounts.', { cssClass: 'alert-danger', timeout: 4000 });
      })
      .finally(() => this.loaderService.hide());
  }

  // Check if child accounts selection has changed
  hasChildAccountsChanged(): boolean {
    const currentSelection = [...this.selectedChildAccounts].sort();
    const original = [...this.originalChildAccounts].sort();
    return JSON.stringify(currentSelection) !== JSON.stringify(original);
  }

  getAccountManagerName(email) {
    if (this.accountManagers && email) {
      const m = this.accountManagers.find(a => a.email === email);
      return m ? m.name : "-"
    } else {
      return "-";
    }
  }

  getWhitelabelName(env) {
    if (this.whitelabels) {
      const m = this.whitelabels.find(w => w.env === env);
      return m ? m.name : "-"
    } else {
      return "-";
    }
  }

  emailListChanged() {
    this.recipientsChanged = true;
  }

  creationEmailListChanged() {
    this.creationEmailRecipientsChanged = true;
  }

  onSendCreationEmail() {
    const emails = this.creationEmailRecipients.map(r => r.value)

    this.loaderService.show()
    this.accountService.sendCreationEmail(this.accountId, emails)
      .then(() => this.flashMessages.show("Creation email sent.", { cssClass: 'alert-success', timeout: 4000, closeOnClick: true }))
      .catch(error => this.flashMessages.show("An error occured.", { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true }))
      .finally(() => this.loaderService.hide());
  }

  resetForm() {
    Object.keys(this.account).filter(x => x !== 'features' && x !== 'addOns').forEach(prop => {
      this.account[prop] = this.orjAccount[prop];
    });
    Object.keys(this.account.features).forEach(prop => {
      this.account.features[prop] = this.orjAccount.features[prop];
    });
    Object.keys(this.account.addOns).forEach(prop => {
      this.account.addOns[prop] = this.orjAccount.addOns[prop];
    });

    Object.keys(this.accountForm.controls).forEach(c => {
      this.accountForm.controls[c].markAsUntouched();
    });
  }

  resetPasswordForm() {
    this.passwordGroup = {
      password: "",
      confirmPassword: ""
    }

    Object.keys(this.passwordForm.controls).forEach(c => {
      this.passwordForm.controls[c].markAsUntouched();
    });
  }

  resetArchiveForm() {
    this.archiveStorage = {
      dedicatedArchive2: this.archiveStorageData.limits.dedicated,
      expireArchive2: this.archiveStorageData.limits.expire
    };
    Object.keys(this.archiveForm.controls).forEach(c => {
      this.archiveForm.controls[c].markAsUntouched();
    });
  }

  onEdit() {
    const detail = this.detailPageService.loadComponent(AccountDetailsComponent).instance;
    detail.action = AccountDetailsComponent.ACTION_EDIT;
    detail.accountId = this.accountId;
  }

  onSaveEmailList() {
    this.loaderService.show();
    setTimeout(() => {
      const changes = {
        accountId: this.accountId,
        emailRecipients: this.emailRecipients.map(r => r.value)
      }
      this.accountService.updateAccount(changes)
      .then(() => { this.recipientsChanged = false; })
      .catch(error => this.flashMessages.show("Cannot update email recipient list."))
      .finally(() => this.loaderService.hide());
    }, 1000);
  }

  onToggleAccountStatus() {
    const modalId = this.modalService.show({
      template: this.toggleTemplate,
      context: {
        dataModel: this.account,
        callbacks: {
          no: () => {
            this.modalService.hide(modalId);
          },
          yes: () => {
            this.loaderService.show();
            this.accountService.toggleAccountStatus(this.accountId)
            .then(disabled => {
              if (disabled) {
                this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.TOGGLE_ACCOUNT_MODAL.DISABLED').toPromise().then(result => {
                  this.flashMessages.show(result, { cssClass: 'alert-success', timeout: 4000, closeOnClick: true });
                });  
              } else {
                this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.TOGGLE_ACCOUNT_MODAL.ENABLED').toPromise().then(result => {
                  this.flashMessages.show(result, { cssClass: 'alert-success', timeout: 4000, closeOnClick: true });
                });  
              }

              const detail = this.detailPageService.loadComponent(AccountDetailsComponent).instance;
              detail.action = AccountDetailsComponent.ACTION_DETAILS;
              detail.accountId = this.accountId;
            })
            .catch(error => {
              this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.TOGGLE_ACCOUNT_MODAL.ERROR').toPromise().then(result => {
                this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
              });
            })
            .finally(() => {
              this.loaderService.hide();
              this.modalService.hide(modalId);
            })
          }
        }
      }
    });
  }

  onDelete() {
    const modalId = this.modalService.show({
      template: this.deleteTemplate,
      context: {
        dataModel: this.account,
        callbacks: {
          no: () => {
            this.modalService.hide(modalId);
          },
          yes: () => {
            this.loaderService.show();
            this.accountService.deleteAccount(this.accountId)
            .then(() => {
              this.detailPageService.removeComponent();
              this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.DELETE_ACCOUNT_MODAL.DELETED').toPromise().then(result => {
                this.flashMessages.show(result, { cssClass: 'alert-success', timeout: 4000, closeOnClick: true });
              });
            })
            .catch(error => {
              this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.DELETE_ACCOUNT_MODAL.ERROR').toPromise().then(result => {
                this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
              });
            })
            .finally(() => {
              this.loaderService.hide();
              this.modalService.hide(modalId);
            })
          }
        }
      }
    });
  }

  onWipe() {
    const modalId = this.modalService.show({
      template: this.wipeTemplate,
      context: {
        dataModel: this.account,
        callbacks: {
          no: () => {
            this.modalService.hide(modalId);
          },
          yes: () => {
            this.loaderService.show();
            this.accountService.wipeAccount(this.accountId)
            .then(() => {
              this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.WIPE_ACCOUNT_MODAL.WIPED').toPromise().then(result => {
                this.flashMessages.show(result, { cssClass: 'alert-success', timeout: 4000, closeOnClick: true });
              });
            })
            .catch(error => {
              this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.WIPE_ACCOUNT_MODAL.ERROR').toPromise().then(result => {
                this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
              });
            })
            .finally(() => {
              this.loaderService.hide();
              this.modalService.hide(modalId);
            })
          }
        }
      }
    });
  }

  onFilesStoringDaysChange(storingDays: number) {
    if (this.action === AccountDetailsComponent.ACTION_NEW) {
      if (storingDays === 0 && this.accountForm.controls.expireArchive.value !== 0) {
        const modalId = this.modalService.show({
          template: this.archiveStoringTimeTemplate,
          context: {
            dataModel: null,
            callbacks: {
              no: () => this.modalService.hide(modalId),
              yes: () => {
                this.accountForm.controls.expireArchive.patchValue(0)
                this.modalService.hide(modalId)
              }
            }
          }
        });
      }
    } else {
      if (storingDays === 0 && this.archiveStorage.expireArchive2 !== 0) {
        const modalId = this.modalService.show({
          template: this.archiveStoringTimeTemplate,
          context: {
            dataModel: null,
            callbacks: {
              no: () => this.modalService.hide(modalId),
              yes: () => {
                this.archiveStorage.expireArchive2 = 0

                this.loaderService.show()
                this.accountService.changeArchiveStorageLimits(this.accountId, this.archiveStorage.dedicatedArchive2, this.archiveStorage.expireArchive2)
                .then(() => {
                  this.archiveStorageData.limits.expire = 0
                  this.resetArchiveForm()
                  this.archiveFormPristine = true;
                  this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.ARCHIVE_LIMITS_CHANGED').toPromise().then(result => this.flashMessages.show(result, { cssClass: 'alert-success', timeout: 4000, closeOnClick: true }));
                  this.modalService.hide(modalId)
                })
                .catch(error => {
                  this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.ARCHIVE_LIMITS_FAILED').toPromise().then(result => this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true }));
                })
                .finally(() => {
                  this.loaderService.hide()
                })
              }
            }
          }
        });
      }
    }
  }

  onControlChange(control: FormControl) {
    if (control.invalid || isNaN(control.value) || control.value < 0 || !Number.isInteger(control.value)) {
      control.setValue(0);
    }
  }

  onWorkflowAccountCheckChange(val: boolean) {
    if (val) {
      this.account.workflowLicenseStartEnd = this.orjAccount.workflowLicenseStartEnd;
    } else {
      this.account.workflowLicenseStartEnd = null;
    }
  }

  onRemoteAccountCheckChange(val: boolean) {
    if (val) {
      this.account.remoteLicenseStartEnd = this.orjAccount.remoteLicenseStartEnd;
    } else {
      this.account.remoteLicenseStartEnd = null;
    }
  }

  onNumericFieldChange(field: NgModel) {
    if (field.invalid || isNaN(field.value) || field.value < 0 || !Number.isInteger(field.value)) {
      this.account[field.name] = 0;
    }
  }

  onWorkflowLicenseFieldChange(field: NgModel) {
    console.log(field)
  }

  onLicenseModelChange(model: string) {
    if (!this.account.demo) {
      if (model === 'starter') {
        Object.keys(this.account.features).filter(key => !this.workflowFeatures.includes(key)).forEach(key => {
          this.account.features[key] = false;
        });
        this.starterFeatures.forEach(key => {
          this.account.features[key] = true;
        });
      } else if (model === 'professional') {
        Object.keys(this.account.features).filter(key => !this.workflowFeatures.includes(key)).forEach(key => {
          this.account.features[key] = false;
        });
        this.professionalFeatures.forEach(key => {
          this.account.features[key] = true;
        });
      } else {
        Object.keys(this.account.features).filter(key => !this.workflowFeatures.includes(key)).forEach(key => {
          this.account.features[key] = true;
        });
        this.account.ultimateTime = 0;
      }
    }
  }

  onLicenseDemoChange(demo: boolean) {
    if (demo) {
      Object.keys(this.account.features).forEach(key => {
        this.account.features[key] = true;
      });
      this.account.ultimateTime = 0;
    } else {
      Object.keys(this.account.features).forEach(key => {
        this.account.features[key] = this.orjAccount.features[key];
      });
    }
  }

  onDedicatedArchiveChange(event) {
    if (this.account.dedicatedArchive < 0) {
      this.account.dedicatedArchive = 0;
    } else if (this.account.dedicatedArchive > 0) {
      this.account.expireArchive = 0;
    }
  }

  onDedicatedArchiveChange2(event) {
    if (this.archiveStorage.dedicatedArchive2 < 0) {
      this.archiveStorage.dedicatedArchive2 = 0;
    } else if (this.archiveStorage.dedicatedArchive2 > 0) {
      this.archiveStorage.expireArchive2 = 0;
    }
  }

  onSmsLimitChange(event) {
    if (this.smsLicense.limit < 0) {
      this.smsLicense.limit = 0;
    }
  }

  onExpireArchiveChange(event) {
    if (this.account.expireArchive < 0) {
      this.account.expireArchive = 0;
    } else if (this.account.expireArchive > 0) {
      this.account.dedicatedArchive = 0;
    }
  }

  onExpireArchiveChange2(event) {
    if (this.archiveStorage.expireArchive2 < 0) {
      this.archiveStorage.expireArchive2 = 0;
    } else if (this.archiveStorage.expireArchive2 > 0) {
      this.archiveStorage.dedicatedArchive2 = 0;
    }
  }

  copied(event) {
    this.flashMessages.show("Copied to clipboard.", { cssClass: 'alert-success', timeout: 4000, closeOnClick: true });
  }

  ngOnDestroy() {
    if (this.formValueSub) { this.formValueSub.unsubscribe() }
    if (this.passFormValueSub) { this.passFormValueSub.unsubscribe() }
    if (this.archiveFormValueSub) { this.archiveFormValueSub.unsubscribe() }
    if (this.activeUsersSub) { this.activeUsersSub.unsubscribe() }
    if (this.accountsManagersSub) { this.accountsManagersSub.unsubscribe() }
    if (this.whitelabelsSub) { this.whitelabelsSub.unsubscribe() }
    if (this.licenseDateThresholdsSub) { this.licenseDateThresholdsSub.unsubscribe() }
    if (this.initialAzureStorageStatusSub) { this.initialAzureStorageStatusSub.unsubscribe() }
  }

  detectAccountChanges(accountId, orjAccount, formValue) {
    let changes: any = {
      accountId: accountId
    }
    if (orjAccount.accountManager !== formValue.accountManager) {
      changes.accountManager = formValue.accountManager ? formValue.accountManager : '';
    }
    if (orjAccount.whitelabel !== formValue.whitelabel) {
      changes.whitelabel = formValue.whitelabel ? formValue.whitelabel : environment.environmentName;
    }
    if (orjAccount.companyName !== formValue.companyName) {
      changes.companyName = formValue.companyName;
    }
    if (orjAccount.adminEmail !== formValue.adminEmail) {
      changes.adminEmail = formValue.adminEmail;
    }
    if (orjAccount.timezone !== formValue.timezone) {
      changes.timezone = formValue.timezone;
    }

    let license: any = {};
    if (orjAccount.roomLimit !== formValue.roomLimit) {
      license.room_limit = formValue.roomLimit.toString();
    }

    if (orjAccount.filesStoringDays !== formValue.filesStoringDays) {
      license.files_storing_days = formValue.filesStoringDays.toString();
    }

    if (orjAccount.licenseType !== formValue.licenseType) {
      license.type = formValue.licenseType;

      if (formValue.licenseType === 'concurrent_user_based') {
        license.account_limit = formValue.licenseLimit.toString();
      } else if (formValue.licenseType === 'expert_user_based') {
        license.room_concurrent_limit = formValue.licenseLimit.toString();
        license.expert_limit = formValue.licenseLimit2.toString();
        license.expert_concurrent_limit = formValue.expertConcurrentLimit.toString();
      }
    } else {
      if (orjAccount.licenseLimit !== formValue.licenseLimit) {
        license.account_limit = formValue.licenseLimit.toString();
        if (formValue.licenseType === 'concurrent_user_based') {
          license.account_limit = formValue.licenseLimit.toString();
        } else if (formValue.licenseType === 'expert_user_based') {
          license.room_concurrent_limit = formValue.licenseLimit.toString();
        }
      }
      if (!isNaN(formValue.licenseLimit2) && orjAccount.licenseLimit2 !== formValue.licenseLimit2) {
        license.expert_limit = formValue.licenseLimit2.toString();
      }
      if (!isNaN(formValue.expertConcurrentLimit) && orjAccount.expertConcurrentLimit !== formValue.expertConcurrentLimit) {
        license.expert_concurrent_limit = formValue.expertConcurrentLimit.toString();
      }
    }
    if (orjAccount.licenseModel !== formValue.licenseModel) {
      license.model = formValue.licenseModel;

      if (orjAccount.ultimateTime > 0 && formValue.licenseModel === 'ultimate' || formValue.licenseModel === 'enterprise') {
        license.ultimate_time = "0";
      }
    }
    if (orjAccount.demo !== formValue.demo) {
      license.demo = formValue.demo;

      if (orjAccount.ultimateTime > 0 && license.demo) {
        license.ultimate_time = "0";
      }
    }
    if (orjAccount.workflowAccount !== formValue.workflowAccount) {
      license.workflow_account = formValue.workflowAccount;
    }
    if (orjAccount.remoteAccount !== formValue.remoteAccount) {
      license.remote_account = formValue.remoteAccount;
    }
    if (!isNaN(formValue.workflowUserLimit) && orjAccount.workflowUserLimit !== formValue.workflowUserLimit) {
      license.workflow_user_limit = formValue.workflowUserLimit.toString();
    }
    if (!isNaN(formValue.workflowLimit) && orjAccount.workflowLimit !== formValue.workflowLimit) {
      license.workflow_limit = formValue.workflowLimit.toString();
    }
    if (!isNaN(formValue.workflowReportLimit) && orjAccount.workflowReportLimit !== formValue.workflowReportLimit) {
      license.workflow_report_limit = formValue.workflowReportLimit.toString();
    }
    if (!isNaN(formValue.ultimateTime) && orjAccount.ultimateTime !== formValue.ultimateTime) {
      license.ultimate_time = formValue.ultimateTime.toString();
    }

    let features: any = {};
    Object.keys(orjAccount.features).forEach(key => {
      if (orjAccount.features[key] !== formValue[key]) {
        features[key] = formValue[key];
      }
    });
    if (Object.keys(features).length > 0) {
      changes.features = features;
    }

    let addOns: any = {};
    Object.keys(orjAccount.addOns).forEach(key => {
      if (orjAccount.addOns[key] !== formValue[key]) {
        addOns[key] = formValue[key];
      }
    });
    if (Object.keys(addOns).length > 0) {
      changes.addOns = addOns;
    }

    if (formValue.remoteAccount) {
      const start = formValue.remoteLicenseStartEnd[0].getTime() - UtilityService.timezoneOffset;
      const end = formValue.remoteLicenseStartEnd[1].getTime() - UtilityService.timezoneOffset;

      if (orjAccount.remoteLicenseStartEnd) {
        const orjStart = orjAccount.remoteLicenseStartEnd[0].getTime() - UtilityService.timezoneOffset;
        const orjEnd = orjAccount.remoteLicenseStartEnd[1].getTime() - UtilityService.timezoneOffset;
  
        if (start !== orjStart || end !== orjEnd) {
          license.remote_start = start.toString();
          license.remote_end = end.toString();
        }
      } else {
        license.remote_start = start.toString();
        license.remote_end = end.toString();
      }
    }
    if (formValue.workflowAccount) {
      const start = formValue.workflowLicenseStartEnd[0].getTime() - UtilityService.timezoneOffset;
      const end = formValue.workflowLicenseStartEnd[1].getTime() - UtilityService.timezoneOffset;

      if (orjAccount.workflowLicenseStartEnd) {
        const orjStart = orjAccount.workflowLicenseStartEnd[0].getTime() - UtilityService.timezoneOffset;
        const orjEnd = orjAccount.workflowLicenseStartEnd[1].getTime() - UtilityService.timezoneOffset;
  
        if (start !== orjStart || end !== orjEnd) {
          license.workflow_start = start.toString();
          license.workflow_end = end.toString();
        }
      } else {
        license.workflow_start = start.toString();
        license.workflow_end = end.toString();
      }
    }
    if (Object.keys(license).length > 0) {
      changes.license = license;
    }
    return changes;
  }

  createSmsLicense() {
    const changes = {
      accountId: this.accountId,
      sms_license: { limit: 0, notify_threshold: 0, prevent_send: true, usage: 0 }
    };
    this.loaderService.show();
    this.accountService.updateAccount(changes)
    .then(() => { this.orjSmsLicense = changes.sms_license; })
    .catch(err => this.flashMessages.show('Cannot create sms license.'))
    .finally(() => this.loaderService.hide())
  }

  deleteSmsLicense() {
    const modalId = this.modalService.show({
      template: this.deleteSmsLicenseTemplate,
      context: {
        dataModel: null,
        callbacks: {
          no: () => this.modalService.hide(modalId),
          yes: () => {
            const changes = {
              accountId: this.accountId,
              sms_license: null
            };
            this.loaderService.show();
            this.accountService.updateAccount(changes).then(() => {
              this.smsLicense = { limit: 0, notify_threshold: 0, prevent_send: true, usage: 0 };
              this.orjSmsLicense = null;
              this.modalService.hide(modalId);
            })
            .catch(err => this.flashMessages.show('Cannot delete sms license.'))
            .finally(() => this.loaderService.hide());
          }
        }
      }
    });
  }

  onSmsFormSubmit(smsForm: NgForm) {
    const changes = {
      accountId: this.accountId,
      sms_license: {
        limit: smsForm.value.smsLimit,
        notify_threshold: smsForm.value.smsNotifyThreshold,
        prevent_send: smsForm.value.preventSend,
        usage: smsForm.value.smsUsage
      }
    };
    this.loaderService.show();
    this.accountService.updateAccount(changes)
    .then(() => {
      this.smsLicense = { limit: smsForm.value.smsLimit, notify_threshold: smsForm.value.smsNotifyThreshold, prevent_send: smsForm.value.preventSend, usage: smsForm.value.smsUsage };
      this.orjSmsLicense = { limit: smsForm.value.smsLimit, notify_threshold: smsForm.value.smsNotifyThreshold, prevent_send: smsForm.value.preventSend, usage: smsForm.value.smsUsage };
      this.smsFormPristine = true;
    })
    .catch(err => this.flashMessages.show('Cannot update sms license.'))
    .finally(() => this.loaderService.hide());
  }

  trainingLicensesFormSubmit() {
    const licenses: {id:string,name:string,publisher:number,concurrent:number,time:number,notify_threshold:number,prevent_join:boolean,time_usage:number}[] = this.trainingLicensesForm.value.licenses;

    let changes: any = {
      accountId: this.accountId,
      training_license: {
        deleted: this.trainingLicenses.filter(l => licenses.findIndex(lf => lf.id === l.id) < 0),
        inserted: licenses.filter(l => this.trainingLicenses.findIndex(lf => lf.id === l.id) < 0),
        changed: licenses.filter(l => this.trainingLicenses.findIndex(lf => lf.id === l.id && (l.name !== lf.name || l.publisher !== lf.publisher || l.concurrent !== lf.concurrent || l.time !== lf.time || l.notify_threshold !== lf.notify_threshold || l.prevent_join !== lf.prevent_join)) > -1)    
      }
    };

    this.loaderService.show();
    this.trainingLicensesForm.disable();
    return this.accountService.updateAccount(changes)
    .then(() => {
      this.trainingLicenses = licenses;

      (this.trainingLicensesForm.controls.licenses as FormArray).clear();
      licenses.forEach(license => this.createTrainingLicense(license.name, license.publisher, license.concurrent, license.time, license.notify_threshold, license.prevent_join, license.time_usage, license.id));

      this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.ACCOUNT_UPDATED').toPromise().then(result => this.flashMessages.show(result, { cssClass: 'alert-success', timeout: 4000, closeOnClick: true }));
    })
    .catch(error => this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.CANNOT_UPDATE').toPromise().then(result => this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true })))
    .finally(() => {
      this.loaderService.hide();
      this.trainingLicensesForm.enable();
    });
  }

  onAccountFormSubmit(form: NgForm, ignoreStoring: boolean = false) {
    if (this.action === this.ACTION_EDIT) {
      const changes = this.detectAccountChanges(this.accountId, this.orjAccount, form.value);
      const adminEmailDeleted = changes.adminEmail === '';
      const fileStoringTimeDecreased = changes.license && changes.license.files_storing_days && this.orjAccount.filesStoringDays > form.value.filesStoringDays;
      if (adminEmailDeleted || fileStoringTimeDecreased) {
        const modalId = this.modalService.show({
          template: this.updateWarningTemplate,
          context: {
            dataModel: { account: this.account, adminEmailDeleted: adminEmailDeleted, fileStoringTimeDecreased: fileStoringTimeDecreased },
            callbacks: {
              close: () => this.modalService.hide(modalId),
              update: () => this.updateAccount(changes).then(() => this.modalService.hide(modalId))
            }
          }
        });
      } else {
        this.updateAccount(changes);
      }
    } else if (this.action === this.ACTION_NEW) {
      if (!ignoreStoring && form.value.filesStoringDays === 0 && form.value.expireArchive !== 0) {
        const modalId = this.modalService.show({
          template: this.archiveStoringTimeTemplate,
          context: {
            dataModel: null,
            callbacks: {
              no: () => {
                this.onAccountFormSubmit(form, true)
                this.modalService.hide(modalId)
              },
              yes: () => {
                this.accountForm.controls.expireArchive.patchValue(0)
                this.onAccountFormSubmit(form, true)
                this.modalService.hide(modalId)
              }
            }
          }
        });
      } else {
        const newAccount: any = {
          account_name: form.value.accountName,
          company_name: form.value.companyName,
          whitelabel: form.value.whitelabel,
          remote_account: form.value.remoteAccount,
          workflow_account: form.value.workflowAccount,
          license_type: form.value.licenseType,
          license_model: form.value.licenseModel,
          license_demo: form.value.demo,
          license_limit: form.value.licenseLimit.toString(),
          room_limit: form.value.roomLimit.toString(),
          files_storing_days: form.value.filesStoringDays.toString(),
          dedicated_archive: form.value.dedicatedArchive.toString(),
          expire_archive: form.value.expireArchive.toString(),
          auto_users_room: this.autoCreateRoomUsers,
          admin_email: form.value.adminEmail,
          timezone: form.value.timezone
        };
        if (form.value.accountManager) {
          newAccount.account_manager = form.value.accountManager;
        }
        if (!this.autoCreateRoomUsers) {
          newAccount.admin_password = form.value.password;
        }
        if (!isNaN(form.value.licenseLimit2)) {
          newAccount.license_limit2 = form.value.licenseLimit2.toString();
        }
        if (!isNaN(form.value.expertConcurrentLimit)) {
          newAccount.expert_concurrent_limit = form.value.expertConcurrentLimit.toString();
        }
        if (!isNaN(form.value.workflowUserLimit)) {
          newAccount.workflow_user_limit = form.value.workflowUserLimit.toString();
        }
        if (!isNaN(form.value.workflowLimit)) {
          newAccount.workflow_limit = form.value.workflowLimit.toString();
        }
        if (!isNaN(form.value.workflowReportLimit)) {
          newAccount.workflow_report_limit = form.value.workflowReportLimit.toString();
        }
        if (form.value.remoteLicenseStartEnd) {
          newAccount.license_remote_start = (form.value.remoteLicenseStartEnd[0].getTime() - UtilityService.timezoneOffset).toString();
          newAccount.license_remote_end = (form.value.remoteLicenseStartEnd[1].getTime() - UtilityService.timezoneOffset).toString();
        }
        if (form.value.workflowLicenseStartEnd) {
          newAccount.license_workflow_start = (form.value.workflowLicenseStartEnd[0].getTime() - UtilityService.timezoneOffset).toString();
          newAccount.license_workflow_end = (form.value.workflowLicenseStartEnd[1].getTime() - UtilityService.timezoneOffset).toString();
        }
        if (!isNaN(form.value.ultimateTime)) {
          newAccount.ultimate_time = form.value.ultimateTime.toString();
        }
        newAccount.features = {};
        Object.keys(this.account.features).forEach(key => {
          newAccount.features[key] = form.value[key];
        });
        newAccount.add_ons = {};
        Object.keys(this.account.addOns).forEach(key => {
          newAccount.add_ons[key] = form.value[key];
        });
        this.accountConfirm(newAccount);
      }
    }
  }

  updateAccount(changes: any) {
    const disabledControls = (this.accountForm.controls ? Object.values(this.accountForm.controls) : []).filter(c => c.disabled);
    this.accountForm.control.disable();
    this.loaderService.show();
    return this.accountService.updateAccount(changes)
    .then(() => {
      this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.ACCOUNT_UPDATED').toPromise().then(result => {
        this.flashMessages.show(result, { cssClass: 'alert-success', timeout: 4000, closeOnClick: true });
      });

      const detail = this.detailPageService.loadComponent(AccountDetailsComponent).instance;
      detail.action = AccountDetailsComponent.ACTION_DETAILS;
      detail.accountId = this.accountId;
    })
    .catch(error => {
      this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.CANNOT_UPDATE').toPromise().then(result => {
        this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
      });
    })
    .finally(() => {
      this.accountForm.control.enable();
      disabledControls.forEach(c => c.disable());
      this.loaderService.hide();
    });
  }

  accountConfirm(newAccount: any) {
    const model = {
      account: newAccount,
      email: {
        recipients: [],
        validator: this.validMailValidatorLong
      }
    };
    const modalId = this.modalService.show({
      template: this.accountConfirmTemplate,
      context: {
        dataModel: model,
        callbacks: {
          close: () => {
            this.modalService.hide(modalId)
          },
          create: () => {
            // If user didnt press enter after add email, wait for auto add
            this.loaderService.show();
            setTimeout(() => {
              this.createAccount(newAccount, model.email.recipients.map(r => r.value)).finally(() => {
                this.modalService.hide(modalId);
              });
            }, 1000);
          }
        }
      }
    });
  }

  createAccount(newAccount: any, customer_emails: string[]) {
    const disabledControls = (this.accountForm.controls ? Object.values(this.accountForm.controls) : []).filter(c => c.disabled);
    this.accountForm.control.disable();
    this.loaderService.show();
    return this.accountService.createAccount(newAccount, customer_emails)
    .then(result => {
      const modalId = this.modalService.show({
        template: this.accountInfoTemplate,
        context: {
          dataModel: result,
          callbacks: {
            close: () => {
              this.modalService.hide(modalId);
            }
          }
        }
      });
      this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.ACCOUNT_CREATED').toPromise().then(result => {
        this.flashMessages.show(result, { cssClass: 'alert-success', timeout: 4000, closeOnClick: true });
      });
      this.detailPageService.removeComponent();

      result.users.forEach(user => {
        if (user.qr) {
          QRCode.toDataURL(user.qr, { width: 300, type: "image/png", errorCorrectionLevel: "M", version: 4 })
          .then(code => { user.qrcode = code })
          .catch(error => console.log(error));
        }
      });
    })
    .catch(error => {
      console.log(error);
      this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.CANNOT_CREATE').toPromise().then(result => {
        this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
      });
      this.accountForm.control.enable();
      disabledControls.forEach(c => c.disable());
    })
    .finally(() => {
      this.loaderService.hide();
    });
  }

  onPasswordFormSubmit(form: NgForm) {
    this.changePassword(form.value.password);
  }

  onArchiveFormSubmit(form: NgForm) {
    this.archiveForm.control.disable();
    this.loaderService.show();
    return this.accountService.changeArchiveStorageLimits(this.accountId, form.value.dedicatedArchive2, form.value.expireArchive2)
    .then(() => {
      this.loaderService.hide();
      const detail = this.detailPageService.loadComponent(AccountDetailsComponent).instance;
      detail.action = AccountDetailsComponent.ACTION_DETAILS;
      detail.accountId = this.accountId;
      this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.ARCHIVE_LIMITS_CHANGED').toPromise().then(result => this.flashMessages.show(result, { cssClass: 'alert-success', timeout: 4000, closeOnClick: true }));
    })
    .catch(error => {
      this.loaderService.hide();
      this.archiveForm.control.enable();
      this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.ARCHIVE_LIMITS_FAILED').toPromise().then(result => this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true }));
    });
  }

  changePassword(newPassword: string) {
    const modalId = this.modalService.show({
      template: this.changePassTemplate,
      context: {
        dataModel: this.account,
        callbacks: {
          no: () => {
            this.modalService.hide(modalId);
          },
          yes: () => {
            this.passwordForm.control.disable();
            this.loaderService.show();
            return this.accountService.changeAdminPassword(this.accountId, newPassword)
            .then(() => {
              this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.CHANGE_ADMIN_PASS_MODAL.ADMIN_PASS_CHANGED').toPromise().then(result => {
                this.flashMessages.show(result, { cssClass: 'alert-success', timeout: 4000, closeOnClick: true });
              });
              const detail = this.detailPageService.loadComponent(AccountDetailsComponent).instance;
              detail.action = AccountDetailsComponent.ACTION_DETAILS;
              detail.accountId = this.accountId;
            })
            .catch(error => {
              this.translateService.get('APP.MAIN.ACCOUNTS.ACCOUNT_DETAILS.CHANGE_ADMIN_PASS_MODAL.CANNOT_CHANGED').toPromise().then(result => {
                this.flashMessages.show(result, { cssClass: 'alert-danger', timeout: 4000, closeOnClick: true });
              });
              this.resetPasswordForm();
            })
            .finally(() => {
              this.modalService.hide(modalId);
              this.passwordForm.control.enable();
              this.loaderService.hide();
            });
          }
        }
      }
    });
  }

  onBack() {
    this.detailPageService.removeComponent();
  }
}
